module.exports = __webpack_public_path__ + "img/aliyun.05625b68.svg";